export default __webpack_public_path__ + "static/schools-custom-mobile-app-7a5b0a9dc6a3abc16bc98faf6d58da3c.jpg";